import { Fish, Save, Trash2 } from 'lucide-react'

interface UserCardProps {
  level: number
  xp: number
  needed: number
  onSave: () => void
  onDeleteSave: () => void
}

export function UserCard({ level, xp, needed, onSave, onDeleteSave }: UserCardProps) {
  const pct = Math.min(100, (xp / needed) * 100)
  return (
    <div className="flex items-center gap-3 rounded-2xl bg-white/70 border border-white/80 backdrop-blur-md px-4 py-2.5 shadow-[0_6px_24px_rgba(70,140,220,0.15)]">
      <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-cyan-400 via-sky-500 to-blue-600 flex items-center justify-center shadow-md shrink-0">
        <Fish className="text-white" size={24} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="font-black text-slate-700 tracking-wide">水族馆长</span>
            <span className="text-[10px] font-black text-white bg-gradient-to-r from-sky-400 to-blue-500 rounded px-1.5 py-0.5 tracking-widest">
              LVL {level}
            </span>
          </div>
          <div className="flex items-center gap-1.5">
            <button
              onClick={onSave}
              className="p-1.5 rounded-lg bg-sky-100/60 hover:bg-sky-200/60 text-sky-600 transition-all active:scale-95"
              title="保存游戏"
            >
              <Save size={14} />
            </button>
            <button
              onClick={onDeleteSave}
              className="p-1.5 rounded-lg bg-red-100/60 hover:bg-red-200/60 text-red-500 transition-all active:scale-95"
              title="删除存档"
            >
              <Trash2 size={14} />
            </button>
          </div>
        </div>
        <div className="flex items-center gap-2 mt-1">
          <div className="h-1.5 flex-1 max-w-[140px] rounded-full bg-slate-200/80 overflow-hidden">
            <div
              className="h-full rounded-full bg-gradient-to-r from-sky-400 to-blue-500 transition-all duration-700"
              style={{ width: `${pct}%` }}
            />
          </div>
          <span className="text-[10px] font-semibold text-slate-400 tabular-nums shrink-0">
            {xp.toLocaleString()} / {needed.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  )
}
